import React from 'react'
import { StepDirection } from 'components/TasksV2/UI/SlideInPanel'
import styles from './styles.module.css'

/** Hidden frames stay mounted: returning to the overview keeps drafts and its own scroll position. */
export function ExecutionFrame({
  active,
  animate,
  direction,
  rtl,
  children,
}: {
  active: boolean
  animate: boolean
  direction: StepDirection
  rtl: boolean
  children: React.ReactNode
}) {
  return (
    <div
      className={styles.frame}
      hidden={!active}
      data-execution-frame
      data-animate={animate}
      data-from={(direction === 'forward') !== rtl ? 'end' : 'start'}
    >
      {children}
    </div>
  )
}
